import React, { useState, useEffect } from 'react';
import {
  Card,
  CardHeader,
  Typography,
  CardContent,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Tabs,
  Tab,
  Box,
  Stack,
  Button,
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import dayjs from 'dayjs';
import { useUserAccesses } from './hooks/useUserAccesses';
import Loading from '../../components/loading';
import ErrorMessage from '../../components/errorMessage';

export default function AccessPage() {
  const [activeTab, setActiveTab] = useState(0);
  const [startDate, setStartDate] = useState(dayjs().startOf('month'));
  const [endDate, setEndDate] = useState(dayjs().endOf('month'));
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const { userAccesses, isLoading, error, fetchUserAccesses } = useUserAccesses();

  const getUserAccesses = () => fetchUserAccesses(startDate, endDate);

  useEffect(() => {
    fetchUserAccesses(startDate, endDate);
  }, []);

  useEffect(() => {
    if (error) {
      setShowErrorMessage(true);
      setErrorMessage('Não foi possível carregar os acessos.');
    }
  }, [error]);

  return (
    <>
      <Loading isToHidden={!isLoading} />
      {showErrorMessage && (
        <ErrorMessage
          message={errorMessage}
          show={showErrorMessage}
          setShow={setShowErrorMessage}
        />
      )}

      <Card variant="outlined" sx={{ borderRadius: 2 }}>
        <CardHeader
          title={
            <Typography variant="h5" sx={{ fontWeight: 'bold' }}>
              Acessos
            </Typography>
          }
        />

        <Box sx={{ borderBottom: 1, borderColor: 'divider', px: 2 }}>
          <Tabs value={activeTab} onChange={(_, newValue) => setActiveTab(newValue)}>
            <Tab label="Quantidade de Acessos" />
          </Tabs>
        </Box>

        <CardContent>
          {activeTab === 0 && (
            <Stack spacing={3}>
              <Stack direction="row" spacing={2} alignItems="center">
                <DatePicker
                  label="Data Inicial"
                  value={startDate}
                  onChange={(date) => setStartDate(date)}
                  format="DD/MM/YYYY"
                />
                <DatePicker
                  label="Data Final"
                  value={endDate}
                  onChange={(date) => setEndDate(date)}
                  format="DD/MM/YYYY"
                />
                <Button variant="contained" onClick={getUserAccesses}>
                  Filtrar
                </Button>
              </Stack>

              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell sx={{ fontWeight: 'bold' }}>Nome do Usuário</TableCell>
                      <TableCell sx={{ fontWeight: 'bold' }}>Data de Acesso</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {userAccesses.length === 0 && !isLoading ? (
                      <TableRow>
                        <TableCell colSpan={2} align="center" sx={{ py: 4 }}>
                          <Typography color="text.secondary">
                            Nenhum acesso encontrado para o período selecionado.
                          </Typography>
                        </TableCell>
                      </TableRow>
                    ) : (
                      userAccesses.map((row) => (
                        <TableRow key={row.id} hover>
                          <TableCell width="50%">{row.userName}</TableCell>
                          <TableCell width="50%">{row.formattedDateFromAccess}</TableCell>
                        </TableRow>
                      ))
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Stack>
          )}
        </CardContent>
      </Card>
    </>
  );
}
